// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sOzCs","selected":"styles_selected__2Qv8D"};